const USER_NOT_ACTIVATED_MESSAGE = 'User not activated';

export { USER_NOT_ACTIVATED_MESSAGE };
